import { Action } from '@ngrx/store';

export const DELETE_CODESYSTEMVERSION_DRAFT_SUCCESS = '[Vocabulary] Delete CodeSystemVersion Draft Success';

export class DeleteCodeSystemVersionDraftSuccessAction implements Action {
  readonly type = DELETE_CODESYSTEMVERSION_DRAFT_SUCCESS;

  constructor(public payload: { success: boolean }) {}
}




// WEBPACK FOOTER //
// ./src/app/vocabulary/store/actions/DeleteCodeSystemVersionDraftSuccessAction.ts